import MatomoJS from '@/assets/lib/matomo'

const analyticsList = new Set()

export const initAnalytics = function() {
  if (!analyticsList.size) {
    const host = 'https://matomo.matpool.com'
    const siteId = 8
    const trackerFileName = 'piwik'
    const trackerEndpoint = `${host}/${trackerFileName}.php`

    const Matomo = MatomoJS.getTracker(trackerEndpoint, siteId)
    Matomo.enableLinkTracking()

    analyticsList.add(Matomo)
  }
}

const getDefineApi = function(key) {
  return function() {
    analyticsList.forEach(item => {
      if (item[key]) {
        item[key](...arguments)
      }
    })
  }
}

const apis = ['setCustomUrl', 'setUserId', 'trackPageView', 'trackEvent']

export default apis.reduce((analyticsApi, key) => {
  analyticsApi[key] = getDefineApi(key)
  return analyticsApi
}, {})
